
$(document).ready(function () {
   $('.select-subject').select2({
      allowClear: false,
      minimumResultsForSearch: -1
   });

   $('.select-subject').on('change', function () {
      var option = $(this).find('option:selected');
      location.href = option.attr('data-action');
   });

   $('.js-blog-back').on('click', function () {
      console.log(document.referrer);
      var ref = document.referrer;
      var domain = $(this).attr('data-domain');
      var back = $(this).attr('data-back')
      if (ref.indexOf(domain) > -1) {
         history.back();
      } else {
         console.log('document.referrer');
         location.href = back;
      }
   })

   $('#search-input').keyup(function () {
      let val = $(this).val();

      if(val.length >= 3) {
         var action = $(this).attr('data-action');
         $.get(action, {'q': val}, function(result) {
            if (result.result) {
               $('.search-container').html(result.result);
               $('.search-container').show();
            } else {
               $('.search-container').hide();
            }
         })
          .fail(function(error) {
             console.log(error);
          })
      } else {
         $('.search-container').hide();
      }
   });
   
   $('#subscription-form').validate({
      highlight: function (element) {
          $(element).addClass("error").removeClass("success");
      },
      unhighlight: function (element) {
          $(element).removeClass("error").addClass("success");
          $(element).siblings('.error').remove();
      },
      //Send form
      submitHandler: function (form) {
         var url = $(form).attr('action');
         var data = $(form).serialize();
         var req = $.ajax({
            method: 'post',
            url: url,
            data: data
         });
         req.done(function(resp) {
            if (resp.success) {
               $('#subscription-form button[type="submit"]').addClass('btn-subs-success');
               $('#subscription-form input').val("");
               setTimeout(function(){
                  $('#subscription-form button[type="submit"]').removeClass('btn-subs-success');
               }, 2000);
            }
            $(form).find('[type=submit]').attr('disabled', false);
         })
         req.fail(function(error) {
            var errors = $.parseJSON(error.responseText);
            $.each(errors.errors, function(key, value) {
               $(form).find('input[name='+key+']').addClass('error');
               $(form).find('input[name='+key+']').after('<label id="'+key+'-error" class="error" for="'+key+'">'+value+'</label>');
            });
         });
      }
   });

   $('#subscription-blog-form').validate({
      highlight: function (element) {
          $(element).addClass("error").removeClass("success");
      },
      unhighlight: function (element) {
          $(element).removeClass("error").addClass("success");
          $(element).siblings('.error').remove();
      },
      submitHandler: function (form) {
         console.log($(form).find(".checkbox-group-wrap input:checked").length);
         if($(form).find(".checkbox-group-wrap input:checked").length){
            $(form).find(".checkbox-group-wrap input").removeClass('error');

            $(form).find('[type=submit]').attr('disabled', true);
            var url = $(form).attr('action');
            var data = $(form).serialize();
            var req = $.ajax({
               method: 'post',
               url: url,
               data: data
            });
            req.done(function(resp) {
               if (resp.success) {
                  $('#subscription-blog-form button[type="submit"]').addClass('btn-subs-success');
                  $('#subscription-blog-form .clear-after-send').val("");
                  setTimeout(function(){
                     $('#subscription-blog-form button[type="submit"]').removeClass('btn-subs-success');
                  }, 2000);
               }
               grecaptcha.reset();
               $(form).find('[type=submit]').attr('disabled', false);
            })
            req.fail(function(error) {
               var errors = $.parseJSON(error.responseText);
               $.each(errors.errors, function(key, value) {
                  if (key == 'g-recaptcha-response') {
                     if ($(form).find('div.js-chaptcha label').length) {
                        $(form).find('div.js-chaptcha label').replace('<label id="' + key + '-error" class="error" for="' + key + '">' + value + '</label>');
                     } else {
                        $(form).find('div.js-chaptcha').after('<label id="' + key + '-error" class="error" for="' + key + '">' + value + '</label>');
                     }
                  }
                  $(form).find('input[name='+key+']').addClass('error');
                  $(form).find('input[name='+key+']').after('<label id="'+key+'-error" class="error" for="'+key+'">'+value+'</label>');
               });
               $(form).find('[type=submit]').attr('disabled', false);
            });
            return false;
         } else {
            $(form).find(".checkbox-group-wrap input").addClass('error');
            return false;
         }
      }
   });
   $('#subscription-blog-form .checkbox-group-wrap input:unchecked').click(function(){
      $("#subscription-blog-form .checkbox-group-wrap input").removeClass('error');
   });

   //iframe
   $(".wysiwyg iframe").each(function() {
      $(this).wrap('<div class="iframe-blog">'); 
   });

   //blog slider

   var countSlide = $('.blog-slider-js .blog-item').length;
   if(countSlide > 2){
      $('.blog-slider-js').not('.slick-initialized').slick({
         dots: true,
         arrows: true,
         infinite: false,
         appendDots: '.slick-dots-new',
         appendArrows: '.slick-dots-new',
         prevArrow:'<span class="slick-button slick-prev"><svg width="5" height="9" viewBox="0 0 5 9" fill="none"><path d="M4.49121 8.28076L0.912264 4.70181L4.49121 1.12287" stroke="#8E90A6"></path></svg></span>',
         nextArrow:'<span class="slick-button slick-next"><svg width="5" height="9" viewBox="0 0 5 9" fill="none"><path d="M0.508789 0.719238L4.08774 4.29819L0.508789 7.87713" stroke="#7E6ECC"/></svg></span>',
         responsive: [
            {
               breakpoint: 5000,
               settings: {
                  slidesToShow: 3,
                  slidesToScroll: 3,
                  rows: 1
               }
            },
            {
               breakpoint: 1000,
               settings: {
                  slidesToShow: 2,
                  slidesToScroll: 2,
                  rows: 1
               }
            },
            {
               breakpoint: 767,
               settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  rows: 3,
                  adaptiveHeight: true
               }
            }
         ]
      });
   }
   function subjectClip(){
     if($('.blog-subject-wrap').length){
         var width = $('.blog-subject-wrap').eq(0).outerWidth(true);
         $('.blog-subject-wrap').each(function(index) {
            var widthInner = 0;
            var indexSub = index;
            $('.blog-subject-wrap').find('.blog-item-subject').each(function(index) {
               var indexClip = index;
               widthInner += $(this).outerWidth(true);
               if(widthInner >= width){

                  $('.blog-subject-wrap').eq(indexSub).find('.blog-item-subject').each(function(index) {
                     if(index >= indexClip){
                        $(this).css('opacity', '0')
                     } else {
                        $(this).css('opacity', '1')
                     }
                  });
                  return false;
               }
            });
         });
      }
   };
   subjectClip();
   $(window).resize(function() {
      subjectClip();
   });
});
